import React from 'react';
import styles from './style.module.css';
import StepThreeForm from '../../components/forms/step-three';

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Know your credit score?</h1>
        <StepThreeForm/>
    </div>
);
